// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TransferFunds_beneficiary__h8Ot0 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  width: 38rem;
  margin-bottom: 3rem;
  cursor: pointer;
}
.TransferFunds_beneficiary__h8Ot0 > * {
  padding: 1rem 0 1rem 0;
  text-align: center;
}
.TransferFunds_beneficiary__saved__cnv9a {
  background-color: var(--color-primary);
  color: var(--color-white);
  border-radius: 1rem 0 0 1rem;
  transition: all 0.4s;
}
.TransferFunds_beneficiary__saved_b__qC9YW {
  border: 1px solid var(--color-primary);
  border-radius: 1rem 0 0 1rem;
  transition: all 0.4s;
}
.TransferFunds_beneficiary__new__9Npdo {
  border: 1px solid var(--color-primary);
  border-radius: 0 1rem 1rem 0;
  transition: all 0.4s;
}
.TransferFunds_beneficiary__new_b__geYNQ {
  background-color: var(--color-primary);
  color: var(--color-white);
  border-radius: 0 1rem 1rem 0;
  transition: all 0.4s;
}

.TransferFunds_pin__FZRRZ {
  display: flex;
  gap: 2rem;
  margin-top: 1rem;
  padding-left: 2rem;
}
.TransferFunds_pin__label__zoAkO {
  font-size: var(--default-font-small);
  font-family: inherit;
  padding-left: 4rem;
}
.TransferFunds_pin__group__xjrke {
  margin-top: 2rem;
}

.TransferFunds_centerContent__0o4rQ {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.TransferFunds_confirmImage__vuED3 {
  width: 20rem;
  margin-bottom: 5rem;
}

.TransferFunds_transferSuccessImg__rlYd- {
  width: 30rem;
  margin-bottom: 5rem;
}

.TransferFunds_transferFailedImg__63Gz6 {
  width: 20rem;
  margin-bottom: 5rem;
}

.TransferFunds_buttonBeside__XPe5I {
  display: flex;
  gap: 3rem;
  align-items: center;
}

.TransferFunds_beneficiaries__t9QsI {
  display: flex;
  align-items: center;
  width: 38rem;
}
.TransferFunds_beneficiaries__t9QsI > :not(:last-child) {
  margin-right: 1rem;
}
.TransferFunds_beneficiaries__details__sU\\+fw {
  width: 33rem;
  cursor: pointer;
}
.TransferFunds_beneficiaries__details__bank__l3DGB {
  text-transform: uppercase;
  font-size: var(--default-font-small);
}
.TransferFunds_beneficiaries__details__sU\\+fw:hover {
  color: var(--color-primary);
  font-weight: 700;
}
.TransferFunds_beneficiaries__delete__iQUZ0 {
  display: flex;
  align-items: center;
  flex-direction: column;
  color: var(--color-error);
  cursor: pointer;
  font-size: 3rem;
}
.TransferFunds_beneficiaries__delete__iQUZ0:hover {
  font-weight: 700;
}
.TransferFunds_beneficiaries__delete__iQUZ0 p {
  font-size: 1.4rem;
  color: var(--color-deep-red);
}

.TransferFunds_line__yqjm4 {
  margin: 1rem 0;
  border-top: 1px solid var(--color-primary);
}

.TransferFunds_bankList__KWIGd {
  width: 38rem;
  cursor: pointer;
}
.TransferFunds_bankList__KWIGd:not(:last-child) {
  margin-bottom: 2rem;
}
.TransferFunds_bankList__KWIGd:hover {
  color: var(--color-primary);
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Wallet/TransferFunds.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,oCAAA;EACA,YAAA;EAEA,mBAAA;EACA,eAAA;AAAD;AAEC;EACC,sBAAA;EACA,kBAAA;AAAF;AAGC;EACC,sCAAA;EACA,yBAAA;EACA,4BAAA;EACA,oBAAA;AADF;AAGE;EACC,sCAAA;EACA,4BAAA;EACA,oBAAA;AADH;AAKC;EACC,sCAAA;EACA,4BAAA;EACA,oBAAA;AAHF;AAKE;EACC,sCAAA;EACA,yBAAA;EACA,4BAAA;EACA,oBAAA;AAHH;;AASA;EACC,aAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AAND;AAQC;EACC,oCAAA;EACA,oBAAA;EACA,kBAAA;AANF;AASC;EACC,gBAAA;AAPF;;AAWA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AARD;;AAUA;EACC,YAAA;EACA,mBAAA;AAPD;;AAUA;EACC,YAAA;EACA,mBAAA;AAPD;;AAUA;EACC,YAAA;EACA,mBAAA;AAPD;;AAUA;EACC,aAAA;EACA,SAAA;EACA,mBAAA;AAPD;;AAWA;EACC,aAAA;EACA,mBAAA;EACA,YAAA;AARD;AASC;EACC,kBAAA;AAPF;AAUC;EACC,YAAA;EACA,eAAA;AARF;AAUE;EACC,yBAAA;EACA,oCAAA;AARH;AAWE;EACC,2BAAA;EACA,gBAAA;AATH;AAaC;EACC,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;AAXF;AAaE;EACC,gBAAA;AAXH;AAcE;EACC,iBAAA;EACA,4BAAA;AAZH;;AAiBA;EACC,cAAA;EACA,0CAAA;AAdD;;AAgBA;EACC,YAAA;EACA,eAAA;AAbD;AAcC;EACC,mBAAA;AAZF;AAeC;EACC,2BAAA;EACA,gBAAA;AAbF","sourcesContent":[".beneficiary {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tbox-sizing: border-box;\n\tfont-size: var(--default-font-small);\n\twidth: 38rem;\n\n\tmargin-bottom: 3rem;\n\tcursor: pointer;\n\n\t& > * {\n\t\tpadding: 1rem 0 1rem 0;\n\t\ttext-align: center;\n\t}\n\n\t&__saved {\n\t\tbackground-color: var(--color-primary);\n\t\tcolor: var(--color-white);\n\t\tborder-radius: 1rem 0 0 1rem;\n\t\ttransition: all 0.4s;\n\n\t\t&_b {\n\t\t\tborder: 1px solid var(--color-primary);\n\t\t\tborder-radius: 1rem 0 0 1rem;\n\t\t\ttransition: all 0.4s;\n\t\t}\n\t}\n\n\t&__new {\n\t\tborder: 1px solid var(--color-primary);\n\t\tborder-radius: 0 1rem 1rem 0;\n\t\ttransition: all 0.4s;\n\n\t\t&_b {\n\t\t\tbackground-color: var(--color-primary);\n\t\t\tcolor: var(--color-white);\n\t\t\tborder-radius: 0 1rem 1rem 0;\n\t\t\ttransition: all 0.4s;\n\t\t}\n\t}\n}\n\n//Pin styles\n.pin {\n\tdisplay: flex;\n\tgap: 2rem;\n\tmargin-top: 1rem;\n\tpadding-left: 2rem;\n\n\t&__label {\n\t\tfont-size: var(--default-font-small);\n\t\tfont-family: inherit;\n\t\tpadding-left: 4rem;\n\t}\n\n\t&__group {\n\t\tmargin-top: 2rem;\n\t}\n}\n\n.centerContent {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n}\n.confirmImage {\n\twidth: 20rem;\n\tmargin-bottom: 5rem;\n}\n\n.transferSuccessImg {\n\twidth: 30rem;\n\tmargin-bottom: 5rem;\n}\n\n.transferFailedImg {\n\twidth: 20rem;\n\tmargin-bottom: 5rem;\n}\n\n.buttonBeside {\n\tdisplay: flex;\n\tgap: 3rem;\n\talign-items: center;\n}\n\n//Beneficiaries\n.beneficiaries {\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 38rem;\n\t& > :not(:last-child) {\n\t\tmargin-right: 1rem;\n\t}\n\n\t&__details {\n\t\twidth: 33rem;\n\t\tcursor: pointer;\n\n\t\t&__bank {\n\t\t\ttext-transform: uppercase;\n\t\t\tfont-size: var(--default-font-small);\n\t\t}\n\n\t\t&:hover {\n\t\t\tcolor: var(--color-primary);\n\t\t\tfont-weight: 700;\n\t\t}\n\t}\n\n\t&__delete {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tflex-direction: column;\n\t\tcolor: var(--color-error);\n\t\tcursor: pointer;\n\t\tfont-size: 3rem;\n\n\t\t&:hover {\n\t\t\tfont-weight: 700;\n\t\t}\n\n\t\tp {\n\t\t\tfont-size: 1.4rem;\n\t\t\tcolor: var(--color-deep-red);\n\t\t}\n\t}\n}\n\n.line {\n\tmargin: 1rem 0;\n\tborder-top: 1px solid var(--color-primary);\n}\n.bankList {\n\twidth: 38rem;\n\tcursor: pointer;\n\t&:not(:last-child) {\n\t\tmargin-bottom: 2rem;\n\t}\n\n\t&:hover {\n\t\tcolor: var(--color-primary);\n\t\tfont-weight: 700;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"beneficiary": `TransferFunds_beneficiary__h8Ot0`,
	"beneficiary__saved": `TransferFunds_beneficiary__saved__cnv9a`,
	"beneficiary__saved_b": `TransferFunds_beneficiary__saved_b__qC9YW`,
	"beneficiary__new": `TransferFunds_beneficiary__new__9Npdo`,
	"beneficiary__new_b": `TransferFunds_beneficiary__new_b__geYNQ`,
	"pin": `TransferFunds_pin__FZRRZ`,
	"pin__label": `TransferFunds_pin__label__zoAkO`,
	"pin__group": `TransferFunds_pin__group__xjrke`,
	"centerContent": `TransferFunds_centerContent__0o4rQ`,
	"confirmImage": `TransferFunds_confirmImage__vuED3`,
	"transferSuccessImg": `TransferFunds_transferSuccessImg__rlYd-`,
	"transferFailedImg": `TransferFunds_transferFailedImg__63Gz6`,
	"buttonBeside": `TransferFunds_buttonBeside__XPe5I`,
	"beneficiaries": `TransferFunds_beneficiaries__t9QsI`,
	"beneficiaries__details": `TransferFunds_beneficiaries__details__sU+fw`,
	"beneficiaries__details__bank": `TransferFunds_beneficiaries__details__bank__l3DGB`,
	"beneficiaries__delete": `TransferFunds_beneficiaries__delete__iQUZ0`,
	"line": `TransferFunds_line__yqjm4`,
	"bankList": `TransferFunds_bankList__KWIGd`
};
export default ___CSS_LOADER_EXPORT___;
